
import BatchDownload from '~/components/BatchDownload'
export default {
  name: 'networkDiskLayout',
  components: { BatchDownload },
  data() {
    return {
      showLoading: false,
      isLogin: false,
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.isLoginValid(route.path)
      },
      deep: true,
      immediate: true,
    },
  },
  fetch() {
    this.isLoginValid(this.$router.currentRoute.path)
  },
  provide() {
    return {
      getScrollContainer: () => this.$refs.scrollContainer
    }
  },
  mounted() {
    this.$bus.$on('showLoading', () => {
      this.showLoading = true
    })
    this.$bus.$on('hideLoading', () => {
      this.showLoading = false
    })
    this.$bus.$on('showRight', (options) => {
      this.$refs.rightMenuBar.show(options)
    })
    /*
    this.$bus.$on('showUpload', (options) => {
      if (options === 'file') {
        this.$refs.fileUploadRef.showUploadFile()
      }
      if (options === 'folder') {
        this.$refs.fileUploadRef.showUploadFolder()
      }
    })*/

    document.addEventListener('keydown', this.handleEscape);
  },
  methods: {
    isLoginValid(path) {
      if (path.includes('/login')) {
        this.isLogin = true
      } else {
        this.isLogin = false
      }
    },
    handleEscape(event) {
      // || event.key === 'Backspace' || event.keyCode === 8
      if (event.key === 'Escape' || event.keyCode === 27) {
        // 处理Esc按键的逻辑
        console.log('Esc key was pressed');
        event.preventDefault();
        event.stopPropagation();
        // 例如，关闭模态框、返回上一页等
      }
    }
  },
}
